import { FC } from 'react'
import Icon from '@/root/ui/shared/Icon'
import { IconProps } from '@/root/shared-types/ui/ui-types'

export const NoTrucksIcon: FC<IconProps> = ({ width = 24, height = 24, ...rest }) => (
  <Icon type="NoTrucks" width={width} height={height} alt="no trucks" {...rest} />
)
